import {FC} from "react";
import {cPaymentsActions} from "@store/consumer/consumerPaymentsStore";
import {toastr} from "@/utils/toastHelper";
import {EditBonusFormValues} from "@components/consumer/payments/bonuses/editBonusForm";
import {usePromisedDispatch} from "@hooks/helperHooks";
import {useNavigate} from "react-router";
import {EditBonusForm} from "@components/consumer/payments/bonuses";
import {EModifyType, EPaymentBonusType, EThresholdType} from "@interfaces/user/payments";
import withPage from "@components/hoc/withPage";

const CreatePaymentBonusPage: FC = () => {

    const navigate = useNavigate();
    const dispatch = usePromisedDispatch();

    const onSubmit = async (values: EditBonusFormValues) => {
        const result = await dispatch(cPaymentsActions.createBonus(values));

        if(result.success) {
            toastr.success('Бонусы за пополнение', 'Бонус успешно создан');
            navigate(`/consumer/payments/bonuses/${result.data.id}/`, { replace: true });
        }
        else {
            toastr.error('Бонусы за пополнение', 'Что-то пошло не так');
        }
    }

    const initial: EditBonusFormValues = {
        name:'',
        isActive: false,
        value: 0,
        type: EPaymentBonusType.Fixed,
        threshold: 1000,
        thresholdType: EThresholdType.OneTime,
        daysOfWeek: [],
        startDate: '',
        startTime: '',
        endDate: '',
        endTime: '',
        aggregators: [],
        hidden: false,
        modifyType: EModifyType.Add
    }

    return (
        <EditBonusForm
            title={`Создание нового бонуса`}
            bonus={initial}
            onSubmit={onSubmit}
        />
    )
}

export default withPage(CreatePaymentBonusPage);